import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import GoogleButton from "@/components/GoogleButton";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e?.preventDefault?.();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      nav("/app/chat");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };


  return (
    <div className="min-h-screen bg-[#F5F9FE] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <Logo size={44} />
          <div className="font-display font-extrabold text-[#0A2A5E] text-2xl tracking-tight">LUMIS HR</div>
        </Link>

        <Card className="p-8 bg-white border-slate-200 shadow-xl rounded-2xl">
          <h1 className="font-display text-2xl font-bold text-[#0A2A5E]">Sign in</h1>
          <p className="text-sm text-slate-500 mt-1">Welcome back to your HR workspace.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1"/>
            </div>
            <div>
              <div className="flex items-center justify-between"><Label htmlFor="password">Password</Label><Link to="/forgot-password" data-testid="forgot-password-link" className="text-xs text-[#0A2A5E] hover:underline">Forgot password?</Link></div>
              <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1"/>
            </div>
            <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full bg-[#0A2A5E] hover:bg-[#0F3F8A] text-white h-11">
              {busy ? "Signing in..." : "Sign in"}
            </Button>
          </form>

          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center"><span className="w-full border-t border-slate-200" /></div>
            <div className="relative flex justify-center text-xs uppercase tracking-widest text-slate-400"><span className="bg-white px-2">or</span></div>
          </div>
          <GoogleButton testid="login-google-btn" />


          <div className="mt-6 text-sm text-center text-slate-600">
            No account? <Link to="/register" data-testid="link-to-register" className="text-[#0A2A5E] font-semibold hover:underline">Create one</Link>
          </div>
        </Card>
      </div>
    </div>
  );
}
